import { useTranslation } from 'react-i18next';
import { CallDirection, FilterOption, GenericValueLabel } from '../../../types';

export const useTrafficMonitorFilters = (direction: CallDirection): FilterOption[] => {
  const { t } = useTranslation('traffic_monitor');
  const httpCodes = [
    200, 201, 202, 203, 204, 300, 301, 302, 303, 304, 305, 400, 401, 402, 403, 404, 405, 500,
    501, 502, 503, 504, 505,
  ];
  const callTypes =
    direction === 'Inbound'
      ? [
          {
            value: 'InboundConsultationRequest',
            label: t('InboundConsultationRequest', 'Inbound Consultation Request'),
          },
          {
            value: 'InboundResponseResult',
            label: t('InboundResponseResult', 'Inbound Response Result'),
          },
          {
            value: 'InboundExtensionResult',
            label: t('InboundExtensionResult', 'Inbound Extension Result'),
          },
        ]
      : [
          {
            value: 'OutboundConsultationNote',
            label: t('OutboundConsultationNote', 'Outbound Consultation Note'),
          },
          {
            value: 'OutboundExtensionRequest',
            label: t('OutboundExtensionRequest', 'Outbound Extension Request'),
          },
          {
            value: 'OutboundConsultationResponse',
            label: t('OutboundConsultationResponse', 'Outbound Consultation Response'),
          },
        ];

  return [
    createFilterOptionItem(
      direction,
      'keyword',
      t('keyword', 'Search for planning applications'),
      undefined,
      false,
      true
    ),
    createFilterOptionItem(direction, 'apiCalls', t('api_call_type', 'API Call'), [
      ...callTypes,
    ]),
    createFilterOptionItem(direction, 'statuses', t('status_type', 'Status'), [
      {
        value: 'success',
        label: t('success', 'Success'),
      },
      {
        value: 'fail',
        label: t('fail', 'Fail'),
      },
    ]),
    createFilterOptionItem(direction, 'httpCodes', t('httpcode_type', 'HTTP Code'), [
      ...httpCodes.map((httpCode) => ({
        value: httpCode,
        label: httpCode.toString(),
      })),
    ]),
  ];
};

export const createFilterOptionItem = (
  direction: CallDirection,
  name: string,
  header: string,
  items: GenericValueLabel[] | undefined,
  allowMultiSelect?: boolean | null,
  isSearchText?: boolean | null
): FilterOption => {
  return {
    name,
    header,
    items: items ?? [],
    selectedItems: [],
    allowMultiSelect: allowMultiSelect ?? true,
    isSearchText: isSearchText ?? false,
  };
};
